module.exports = __webpack_public_path__ + "static/media/refund-failed-red.6c23e89e.svg";